export default __webpack_public_path__ + "static/media/lafcn-logo-branco.1517225c.png";